import React, { useState, useEffect } from "react";
import { API } from "aws-amplify";
import { validatorRadios } from "../Utils/validators";
import ErrorCustom from "./errorCustom";
import { useSelector } from "react-redux";

function WapperInvestmentProfile({
  errors,
  setLoading,
  setError,
  clearError,
  setValue,
  defaultValue,
  setActiveNext,
  register,
  value,
}) {
  const [displayContent, setDisplayContent] = useState();
  const [qaData, setQaData] = useState("");
  const updatedData = useSelector((state) => state.data);
  const handleQuestion = (e) => {
    setDisplayContent(e.currentTarget.value);
  };

  const handleOnChange = (e) => {
    // console.log(e.currentTarget.value);
  };

  const getQuestionsAndAnswers = async () => {
   
    try {
      const payload = {
        canalOrigen: "JOURNEY_INVERSION",
      };
      if (updatedData.contratant) {
        if (!Object.entries(updatedData.contratant).length) {
          updatedData.contratant = updatedData.assured;
        }
      }
      if (updatedData.assured) {
        payload.asegurado = {};
        payload.asegurado.tipoDocumento = updatedData.assured.typeDoc;
        payload.asegurado.apellidoPaterno = updatedData.assured.firstName;
        payload.asegurado.fechaNacimiento =
          updatedData.assured.birthday === undefined ? '' : updatedData.assured.birthday;
        payload.asegurado.numeroDocumento = updatedData.assured.nroDoc;
        payload.asegurado.sexo = updatedData.assured.sexo;
        payload.asegurado.apellidoMaterno = updatedData.assured.lastName;
        payload.asegurado.nombres = updatedData.assured.names;
        payload.asegurado.CC = updatedData.assured.CC;
        payload.asegurado.LPDP = updatedData.assured.LPDP;
        payload.asegurado.celular = updatedData.assured.phone;
        payload.asegurado.correo = updatedData.assured.email;
      }

      if (updatedData.contratant) {
        payload.contratante = {};
        payload.contratante.tipoDocumento = updatedData.contratant.typeDoc;
        payload.contratante.apellidoPaterno = updatedData.contratant.firstName;
        payload.contratante.fechaNacimiento =
          updatedData.contratant.birthday === undefined ? '' : updatedData.contratant.birthday;
        payload.contratante.numeroDocumento = updatedData.contratant.nroDoc;
        payload.contratante.apellidoMaterno = updatedData.contratant.lastName;
        payload.contratante.sexo = updatedData.contratant.sexo;
        payload.contratante.nombres = updatedData.contratant.names;
        payload.contratante.CC = updatedData.contratant.CC;
        payload.contratante.LPDP = updatedData.contratant.LPDP;
        payload.contratante.celular = updatedData.contratant.phone;
        payload.contratante.correo = updatedData.contratant.email;
      }

      const myInit = {
        body: payload,
        headers: {},
      };
      setLoading(true);
      await API.post(
        "api-rentas",
        "/perfilamiento/obtener",
        myInit
      )
        .then((response) => {
          let data = response.payload.data
          if (response.payload.data.preguntasRespuestas) {
            let respuestas = response.payload.data.preguntasRespuestas
            data.preguntas[0].respuestas.map(item => {
              respuestas.map(x => {
                if (item.codigo === x.respuesta) {
                  item.value = x.respuesta
                  setDisplayContent(item.codigo)
                  if (item.preguntas) {
                    item.preguntas.map(resp => {
                      respuestas.map(x => {
                        if (resp.codigo === x.pregunta) {
                          resp.respuestas.map(z => {
                            if (z.codigo === x.respuesta) {
                              z.value = x.respuesta
                            }
                          })
                        }
                      })
                    })
                  }
                } 
              })
            })
          }
          setQaData(data);
        })
        .catch((error) => {
          console.log("promise error", error);
        });
    } catch (ex) {
      console.log(ex);
    }

    setLoading(false);
  };

  useEffect(() => {
    getQuestionsAndAnswers();
  }, [updatedData]);

  return (
    <div className="wapperGetClient">
      <div className="wapperGetClient__group">
        <div className="clientForm__control__radioButton">
          {qaData !== "" &&
            Object.entries(qaData).length &&
            qaData.preguntas.length &&
            qaData.preguntas.map((i, index) => (
              <div key={index}>
                <p>{i.pregunta}</p>
                {i.respuestas.map((x, index) => (
                  <div key={index}>
                    <div className="clientForm__control__radioButton__item">
                      <input
                        type="radio"
                        name={i.codigo}
                        id={x.codigo}
                        value={x.codigo}
                        defaultChecked ={ x.value === x.codigo}
                        ref={register({ validate: validatorRadios })}
                        onChange={handleQuestion}
                      />
                      <label htmlFor={x.codigo} />
                      <span>{x.respuesta}</span>
                    </div>
                  </div>
                ))}
                <ErrorCustom errors={errors} name={i.codigo} />
              </div>
            ))}
        </div>
      </div>
      <div className="wapperGetClient__group">
        {displayContent === "PERFINVP01R02" &&
          qaData !== "" &&
          qaData.preguntas[0].respuestas[1].preguntas.map((y, index) => (
            <div key={index} className="clientForm__control__radioButton">
              <p>{y.pregunta}</p>
              {y.respuestas.map((z, index) => (
                <div
                  key={index}
                  className="clientForm__control__radioButton__item"
                >
                  <input
                    type="radio"
                    name={y.codigo}
                    id={z.codigo}
                    value={z.codigo}
                    defaultChecked ={ z.value === z.codigo}
                    ref={register({ validate: validatorRadios })}
                    onChange={handleOnChange}
                  />
                  <label htmlFor={z.codigo} />
                  <span>{z.respuesta}</span>
                </div>
              ))}
              <ErrorCustom errors={errors} name={y.codigo} />
            </div>
          ))}
      </div>
    </div>
  );
}
export default WapperInvestmentProfile;
